import Vue from 'vue'
import Vuex from 'vuex'
import {typeProductsCollection, db} from '@/FirebaseConfig'
import {cleanObject,secondsToFullTimestamp} from '@/Helper.js' 
Vue.use(Vuex)
export default {
    namespaced:true,
    state: {
        data:{
            name:'',
            createdAt:'',
        },
        record:{},
        selectedKey:'',
        dialog:false,
    },
    mutations: {
        getAllItems(state, item) {
           Vue.set( state.record, item.id,  {...item.data(),creado_el: secondsToFullTimestamp(item.data().createdAt)} )
        },
        clean(state,key){
            Vue.delete(state.record, key)
        },
    },
    actions: {
        getAll:context=>{
            context.state.record = {}
            typeProductsCollection.onSnapshot(data=>data.docs.map( item => context.commit( 'getAllItems',item  ) ) )
        },
        add:context=>{
            if(context.state.selectedKey==''){
              typeProductsCollection.add({...context.state.data,creado_el:new Date}).then(()=>{
                context.commit('Helpers/launchSnackbar', 'Se ha registrado un nuevo tipo de producto correctamente', { root: true })
                cleanObject(context.state.data)
                context.state.dialog = false
                })
            }else{
            context.state.selectedKey
            typeProductsCollection.doc(context.state.selectedKey).update(context.state.data).then(()=>{
                context.commit('Helpers/launchSnackbar', ' Ha sido modificado correctamente', { root: true })                  
                cleanObject(context.state.data)
                context.state.dialog = false
                })
            }
        },
        massiveAdd: (context, data) =>{
            let batch = db.batch()
            let count = 0
            data.map(item => {
                batch.set(typeProductsCollection.doc(), {...item, createdAt: new Date()})
                count++   
            })
            batch.commit().then( () =>  context.commit('Helpers/launchSnackbar', `Se han hecho ${count} registros`, { root: true }) )
        },
        clean:(context, key)=>{
            typeProductsCollection.doc(key).delete().then(()=>{
                context.commit('Helpers/launchSnackbar', 'Se ha eliminado con éxito', { root: true })                
                context.commit('clean',key)})
        },
        get:(context,key)=>{
            typeProductsCollection.doc(key).get().then(doc=>{
              context.state.data=doc.data()
              context.state.selectedKey=key
              context.state.dialog = true
            })
        },
        clearForm:(context)=>{
            context.state.dialog = false
            context.state.selectedKey = ''
            context.state.data = {
              name: '',
              createdAt: ''
            }
        },
    },
    getters:{
        record: state =>Object.keys(state.record).map(item =>({...state.record[item],key:item}))
        }    
}